module.exports = __webpack_public_path__ + "static/img/r-5-4-icon.7b840a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-5/r-5-4-icon.png
// module id = KDGw
// module chunks = 0